import React from 'react';
import { Table } from 'react-bootstrap';
import THead from "./components/THead";
import Row from "./components/Row";
import TotalRow from './components/TotalRow';
import {roundTo3Decimal, sortArray} from "../../../../Utils";
import { calculateECost } from "../../prepareReport";

const DaysTable = ({ reportObj, subids, device, countries, sortParam, sortOrder, onSortChange }) => {
    const { report, days } = reportObj;
    const rowsData = getRowsData(report, days, subids, device, countries);
    const total = calcTotal(rowsData, days);

    if(sortParam) sortArray(rowsData, sortParam, sortOrder);

    const rows = rowsData.map(row => <Row {...row} days={days} key={`${row.affid}:${row.subid}:${row.device}`}/>);

    return (
        <Table bordered responsive>
            <THead days={days} onSortChange={onSortChange}/>
            <tbody>
                <TotalRow data={total} days={days} />
                {rows}
            </tbody>
        </Table>
    )
};

function calcTotal(data, days) {
    const totals = data.reduce((obj, { daysData }) => {
        days.forEach(day => {
            const dayData = daysData[day];

            if(!obj[day]) obj[day] = { spends: 0, conversions: 0 };

            if(dayData.spends) obj[day].spends += dayData.spends;
            if(dayData.conversions) obj[day].conversions += dayData.conversions;
        });

        return obj;
    }, {});

    Object.keys(totals).forEach(day => totals[day].eCost = calculateECost(totals[day].spends, totals[day].conversions));

    return totals;
}

function getRowsData(report, days, subids, selectedDevice, countries) {
    return report.reduce((arr, { affid, subid, device, daysData }) => {
        let isMatchFilters = true;

        if(subids.length && subids.indexOf(subid) === -1) isMatchFilters = false;
        else if(selectedDevice && selectedDevice !== device ) isMatchFilters = false;

        if(isMatchFilters) {
            if(countries.length) countries.forEach(country => arr.push({ affid, subid, device, country, daysData: getDayData(daysData, days, country) }));
            else arr.push({ affid, subid, device, daysData: getDayData(daysData, days) });
        }

        return arr;
    }, []);
}

function getDayData(data, days, country) {
    return days.reduce((obj, day) => {
        obj[day] = getValues(data[day], country);

        return obj;
    }, {});
}

function getValues(data, country) {
    let spends = 0, conversions = 0, eCost = 0;
    if(data) {
        if(data.spends) spends = country ? data.spends[country] : data.totalSpends;
        if(data.conversions) conversions = country ? data.conversions[country] : data.totalConversions;
        if(data.eCost) {
            eCost = country ? data.eCost[country] : data.avgECost;
            if(eCost) eCost = roundTo3Decimal(eCost);
        }
    }

    return { spends, conversions, eCost };
}

export default DaysTable;


// WEBPACK FOOTER //
// ./src/scenes/BidderECost/components/DaysTable/index.js